(() => {
  const labelReviewControls = () => {
    const heading = document.querySelector('.agrs__widget-title');
    const reviewLink = document.querySelector('.agrs__holder > .agrs__card__link[target="_blank"][rel~="noopener"]');

    if (heading && !heading.textContent.trim() && !heading.getAttribute('aria-label')) {
      heading.setAttribute('aria-label', 'Customer reviews');
    }

    if (reviewLink && !reviewLink.textContent.trim() && !reviewLink.getAttribute('aria-label')) {
      reviewLink.setAttribute('aria-label', 'Leave Snackswift a Google review');
    }

    return Boolean(heading && reviewLink);
  };

  if (labelReviewControls()) return;

  const observer = new MutationObserver(() => {
    if (labelReviewControls()) observer.disconnect();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 10000);
})();
